export default class HashNav {
  constructor(drawer, tab) {
    this.drawer = drawer
    this.tab = tab
    this.amount = 0
    this.hash()

    window.onhashchange = () => {
      this.hash()
    }
  }

  hash () {
    const original = window.location.hash
    const stripped = original.split('?')
    const hash = stripped[0]

    if (stripped[1]) {
      const queries = stripped[1].split('=')

      if (queries[0] === 'amount') {
        this.amount = queries[1]
      }
    }

    if (hash) {
      var block = document.getElementById(hash.substring(1));
      if(block != null && /drawer/.test(block.className))
      {
        this.drawer.searchDrawer('OPEN', block);
      }
      else
      {
        let method = camelize(hash.substring(1)).replace('-','')
        if (this[method]) {
         this[method]()
        }
      }
    }
  }

  giving () {
    this.drawer.searchDrawer('OPEN', this.drawer._drawerInit[0])
  }

  givingMonthly () {
    this.drawer.searchDrawer('OPEN', this.drawer._drawerInit[0])
    this.tab._tab[1]
    this.tab.getContent(this.tab._tab[1], this.tab._tab[1].dataset.id)
    this.tab.switchHeader(this.tab._tab[1].dataset.id)

    if (this.amount) {
      const input = document.getElementById('monthly-amount')
      const inputCents = document.getElementById('monthly-amount-cents')
      input.value = this.amount
      input.setAttribute('value', this.amount)
      inputCents.value = this.amount*100
      inputCents.setAttribute('value', this.amount*100)
    }
  }

  media () {
    this.drawer.searchDrawer('OPEN', this.drawer._drawer[3])
  }

  fundraising () {
    this.drawer.searchDrawer('OPEN', this.drawer._drawer[4])
  }
}

  const camelize = function (str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }
